<script>
    export let isSelected = false,
        name = "some-radio-button-name";
</script>

<div class="checkbox-icon" on:click>
    <input type="radio" {name} checked="{isSelected}" on:click />
    <i class="material-icons unchecked">lens</i>
    <i class="material-icons checked">check_circle</i>
</div>

<style>
    /* checkbox (Laura's checkbox code from /premium/enrollment experiment. */

    .checkbox-icon {
        display: inline-block;
        height: 20px;
        width: 20px;
        margin-right: 16px;
        position: relative;
    }

    .checkbox-icon input {
        opacity: 0; /* hide but function */
        height: 20px;
        width: 20px;
        cursor: pointer;
    }

    .checkbox-icon i.material-icons {
        height: 20px;
        width: 20px;
        position: absolute;
        top: -2px;
        left: 0;
        pointer-events: none;
    }

    .checkbox-icon i.checked {
        color: #2284f7;
    }

    .checkbox-icon i.unchecked {
        color: #e6e6e6;
    }

    .checkbox-icon input:checked ~ i.checked,
    .checkbox-icon input:not(:checked) ~ i.checked {
        opacity: 1; /* show */
    }

    .checkbox-icon input:checked ~ i.unchecked,
    .checkbox-icon input:not(:checked) ~ i.checked {
        opacity: 0; /* hide */
    }
</style>
